<template>
<div class="container">
<b-row v-if="!isLoading">
<h5>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;muestreLista=false">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label v-if="paises">País</label>
	<select v-if="paises" v-model="pais">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select> &nbsp;&nbsp;
	<span v-if="pais && paises">
		<label v-if="desde && hasta" >Consulta por:</label> &nbsp;
		<label v-if="desde && hasta" for="Fecha">Fecha</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Fecha" value="Fecha" v-on:click="uncheck(1)" > &nbsp; &nbsp;
		<label v-if="desde && hasta" for="Proveedor">Proveedor</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Proveedor" value="Proveedor" v-on:click="uncheck(2)"> &nbsp;&nbsp;		
		<label v-if="desde && hasta" for="Analista">Analista</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Analista" value="Usuario" v-on:click="uncheck(3)"> &nbsp;&nbsp;
		<label v-if="desde && hasta" for="Estado">Estado</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Estado" value="Estado" v-on:click="uncheck(4)"> &nbsp;&nbsp;
		<md-button v-if="desde && hasta && opcion" class="md-primary md-raised" @click="f_consulta_informacion()"><h5>Consultar</h5></md-button>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		<md-button v-if="desde && hasta && opcion && opcion!='estado'" class="md-primary md-raised" @click="f_consulta_metricas()"><h5>Metricas</h5></md-button>
	</span>
</h5>
<b-container v-if="fgl_muestreOpciones">
	<md-table v-model="listInformacionNovedades" md-card md-fixed-header @md-selected="f_muestra_facturas">
	<md-table-toolbar>
		<h5 class="md-title"><b><i>{{f_titulo()}}&nbsp;&nbsp;&nbsp;&nbsp;(Leidos&nbsp;&nbsp;{{listInformacionNovedades.length}})</i></b></h5>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell v-if="opcion=='fecha'" :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
		<md-table-cell v-if="opcion=='proveedor'" :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
		<md-table-cell v-id="proveedor" v-if="opcion=='proveedor'" :md-label="labels.nombre" class="text-left border">{{item.nombre}}</md-table-cell>
		<md-table-cell v-if="opcion=='analista'" :md-label="labels.idAnalista" class="text-left border">{{item.id_usuario}}</md-table-cell>
		<md-table-cell v-if="opcion=='analista'" :md-label="labels.analista" class="text-left border">{{f_nombre_usuario(item.id_usuario)}}</md-table-cell>
		<md-table-cell v-if="opcion=='estado'" :md-label="labels.analista" class="text-left border">{{item.estado}}</md-table-cell>
		<md-table-cell v-if="opcion=='estado'" :md-label="labels.estado" class="text-left border">{{f_nombre_estado(item.estado)}}</md-table-cell>
		<md-table-cell :md-label="labels.cuantos" class="text-left border">{{item.cuantos}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>

<b-container v-if="fgl_muestreMetricas == true">
	<md-table>
	</md-table>
	<md-table v-model="listInformacionMetricas" md-card md-fixed-header>
		<md-table-toolbar>
			<h5 class="md-title"><b><i>{{f_titulo_metricas()}}&nbsp;&nbsp;&nbsp;(Leidos&nbsp;&nbsp;{{listInformacionMetricas.length}})</i></b></h5>
		</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" >
		<md-table-cell v-if="opcion=='fecha'" md-label="Fecha" class="text-center border">{{f_formato_fecha(item.fecha)}}</md-table-cell>
		<md-table-cell v-if="opcion=='proveedor'" md-label="Proveedor" class="text-left border" width="105px" >{{item.proveedor}}</md-table-cell>
		<md-table-cell v-if="opcion=='proveedor'" md-label="Nombre             *" class="text-left border" width="250">{{item.nombre}}</md-table-cell>
		<md-table-cell v-if="opcion=='analista'" md-label="Cod" class="text-left border">{{item.analista}}</md-table-cell>
		<md-table-cell v-if="opcion=='analista'" md-label="Nombre              *" class="text-left border" width="250">{{item.nombre}}</md-table-cell>
		<md-table-cell v-if="item.total >= 1" :md-label="titulo1" class="text-center border">{{item.campo1}}</md-table-cell>
		<md-table-cell v-if="item.total >= 2" :md-label="titulo2" class="text-center border">{{item.campo2}}</md-table-cell>
		<md-table-cell v-if="item.total >= 3" :md-label="titulo3" class="text-center border">{{item.campo3}}</md-table-cell>
		<md-table-cell v-if="item.total >= 4" :md-label="titulo4" class="text-center border">{{item.campo4}}</md-table-cell>
		<md-table-cell v-if="item.total >= 5" :md-label="titulo5" class="text-center border">{{item.campo5}}</md-table-cell>
		<md-table-cell v-if="item.total >= 6" :md-label="titulo6" class="text-center border">{{item.campo6}}</md-table-cell>
		<md-table-cell v-if="item.total >= 7" :md-label="titulo7" class="text-center border">{{item.campo7}}</md-table-cell>
		<md-table-cell v-if="item.total >= 8" :md-label="titulo8" class="text-center border">{{item.campo8}}</md-table-cell>
		<md-table-cell v-if="item.total >= 9" :md-label="titulo9" class="text-center border">{{item.campo9}}</md-table-cell>
		<md-table-cell v-if="item.total >= 10" :md-label="titulo10" class="text-center border">{{item.campo10}}</md-table-cell>
		<md-table-cell v-if="item.total >= 11" :md-label="titulo11" class="text-center border">{{item.campo11}}</md-table-cell>
		<md-table-cell v-if="item.total >= 12" :md-label="titulo12" class="text-center border">{{item.campo12}}</md-table-cell>
		<md-table-cell v-if="item.total >= 13" :md-label="titulo13" class="text-center border">{{item.campo13}}</md-table-cell>
		<md-table-cell v-if="item.total >= 14" :md-label="titulo14" class="text-center border">{{item.campo14}}</md-table-cell>
		<md-table-cell v-if="item.total >= 15" :md-label="titulo15" class="text-center border">{{item.campo15}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>

<b-container v-if="fgl_muestreFacturas">
	<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_muestra_novedad">
	<md-table-toolbar>
		<h5 class="md-title"><b><i>{{f_titulo()}}</i></b></h5>
	</md-table-toolbar>
	<md-table-head>
		<md-head-row>
		<md-header>{{labels.fecha}}</md-header>
		</md-head-row>
	</md-table-head>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.fecha" class="text-left border" witdth="20%">{{item.fecha_factura}}</md-table-cell>
		<md-table-cell :md-label="labels.documento" class="text-left border" width="3%">{{item.documento}}</md-table-cell>
		<md-table-cell :md-label="labels.factura" class="text-left border" width="12%">{{item.factura}}</md-table-cell>
		<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
		<md-table-cell :md-label="labels.nombre" class="text-left border" width="25%">{{item.nombre}}</md-table-cell>
		<md-table-cell :md-label="labels.pedido" class="text-left border">{{item.pedido}}</md-table-cell>
		<md-table-cell :md-label="labels.estado" class="text-left border">{{f_nombre_estado(item.estado)}}</md-table-cell>
		<md-table-cell :md-label="labels.analista" class="text-left border">{{f_nombre_usuario(item.id_usuario)}}</md-table-cell>
	</md-table-row>
	</md-table>
	<md-table >
	<md-table-row >
		<md-table-cell class="text-center border">
			<md-button class="md-accent" @click="fgl_muestreFacturas=false;fgl_muestreOpciones=true;muestreLista=false">Regresar</md-button>
		</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
</b-row>
<b-row>
<b-container v-if="muestreLista">
	<md-table v-if="listNovedades.length>0" v-model="listNovedades" md-card md-fixed-header @md-selected="f_muestra_detalle">
	<md-table-toolbar>
		<h5 class="md-title"><b><i>{{f_titulo_novedad()}}</i></b></h5>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.fecha_novedad" class="text-left border">{{f_fecha(item.fecha_novedad)}}</md-table-cell>
		<md-table-cell :md-label="labels.tipo_novedad" class="text-left border">{{f_estado(item.tipo_novedad)}}</md-table-cell>
		<md-table-cell :md-label="labels.pedido" class="text-left border">{{item.pedido}}</md-table-cell>
		<md-table-cell :md-label="labels.llave" class="text-left border">{{item.llave}}</md-table-cell>
		<md-table-cell :md-label="labels.documento_contable" class="text-left border">{{item.documento_contable}}</md-table-cell>
		<md-table-cell :md-label="labels.item" class="text-left border">{{item.item}}</md-table-cell>
		<md-table-cell :md-label="labels.descripcion" class="text-left border">{{item.descripcion}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidad_sap" class="text-left border">{{item.cantidad_sap}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidad_fe" class="text-left border">{{item.cantidad_fe}}</md-table-cell>
		<md-table-cell :md-label="labels.precio_sap" class="text-left border">{{item.precio_sap}}</md-table-cell>
		<md-table-cell :md-label="labels.precio_fe" class="text-left border">{{item.precio_fe}}</md-table-cell>
	</md-table-row>
	</md-table>
	<md-table v-if="listNovedades.length==0" md-card>
	<md-table-row>
		<md-table-cell><b><i>Documento sin novedades</i></b></md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
</b-row>
</div>
</template>
<script>
import Novedades from "@/services/Novedades"
import User from "@/services/User"
import Estado from "@/services/Estados"

export default {
name:'Novedades',
data: () => ({
	isLoading: false,
	fgl_reportar: false,
	fgl_muestreFacturas: false,
	fgl_muestreOpciones: false,
	fgl_muestreMetricas: false,
	muestre_reportar : false,
	boton_reportar: '',
	pais: '',
	paises: false,
	users : [],
	novedad: '',
	listEstados : [],
	listPaises : [],
	listNovedades : [],
	listFacturas : [],
	listInformacionNovedades : [],
	listInformacionMetricas : [],
	listInformacionMetricasP : [],
	listTitulosMetricas : [],
	muestreLista: false,
	muestreDetalle: false,
	desde: '',
	hasta: '',
	Fecha: false,
	Analista: false,
	Proveedor: false,
	opcion: '',
	factura: {},
	titulo1:	'',
	titulo2:	'',
	titulo3:	'',
	titulo4:	'',
	titulo5:	'',
	titulo6:	'',
	titulo7:	'',
	titulo8:	'',
	titulo9:	'',
	titulo10:	'',
	titulo11:	'',
	titulo12:	'',
	titulo13:	'',
	titulo14:	'',
	titulo15:	'',
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			tipo_novedad: "Tipo Novedad",
			factura : "Número Factura",
			fecha_novedad : "Fecha Novedad",
			rut_proveedor : "Identificación",
			razon_social : "Nombre del Proveedor",
			pedido : "Pedido",
			impuesto : "Total Impuesto",
			valor_total : "Total Factura",
			llave : "Llave",
			documento_contable : "Doc Contable",
			item : "Item",
			descripcion : "Descripcion",
			fecha: "Fecha",
			estado: "Estado",
			identificacion: "Proveedor",
			nombre: "Nombre Proveedor",
			analista: "Analista",
			idAnalista: "Codigo",
			cuantos: "Facturas",
			documento: "TipoDC",
			lider: "Lider",
			usuario: "Usuario",
			precio_fe: "PrecioFE",
			cantidad_fe: "CantFE",
			iva_fe: "IvaFE",
			impuesto_fe: "ImpFE",
			valor_fe: "TotalFE",
			precio_sap: "PrecioSAP",
			cantidad_sap: "CantSAP",
			iva_sap: "IvaSAP",
			impuesto_sap: "ImpSAP",
			valor_sap: "TotalSAP",
			reportar: "Reportar",
			resuelta: "Resuelta",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			estado: "Condition",
			lider: "Leader",
			lider_nombre: "Leader Name",
			usuario: "User",
			usuario_nombre: "User Name",
		}
	}
}
},
mounted(){
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Estado.leaEstados()
	.then((result) => {
		this.listEstados = result.data.listEstados;
	})
	.catch((err) => {
		console.log(err)
	})
	switch (this.$route.name) {
	case  "Snovedades" :
		Novedades.leaPaises(null)
		.then((res) => {
			this.listPaises = res.data.listPaises
			this.pais=''
			if	(this.listPaises.lenght==0) {
				this.paises=false
			}
		})
		this.boton_reportar = this.labels.reportar
		this.muestre_reportar = true
		break;
	case  "Rnovedades" :
		Novedades.leaPaises(200)
		.then((res) => {
			this.listPaises = res.data.listPaises
			this.pais=''
			if	(this.listPaises.lenght==0) {
				this.paises=false
			}
		})
		this.boton_reportar = this.labels.resuelta
		this.muestre_reportar = true
		break;
	case  "RESnovedades" :
		Novedades.leaPaises(300)
		.then((res) => {
			this.listPaises = res.data.listPaises
			this.pais=''
			if	(this.listPaises.lenght==0) {
				this.paises=false
			}
		})
		this.muestre_reportar = false
		break;
	}

},
methods:{
	f_titulo() {
		let v_titulo=''
		v_titulo="REGISTRO CONTABILIZACIONES ENTRE "+this.desde+" Y "+this.hasta
		if	(this.opcion == "fecha") {
			v_titulo=v_titulo+" POR FECHA"
		}
		if	(this.opcion == "proveedor") {
			v_titulo=v_titulo+" POR PROVEEDOR"
		}
		if	(this.opcion == "analista") {
			v_titulo=v_titulo+" POR ANALISTA"
		}
		if	(this.opcion == "estado") {
			v_titulo=v_titulo+" POR ESTADO"
		}
		return v_titulo
	},
	f_titulo_novedad() {
		let v_titulo="NOVEDADES: "+this.factura.factura+" "+
		this.factura.identificacion+" "+
			this.factura.nombre
		return v_titulo
	},
	f_titulo_metricas() {
		let v_titulo=''
		v_titulo="METRICAS ENTRE "+this.desde+" Y "+this.hasta
		if	(this.opcion == "fecha") {
			v_titulo=v_titulo+" POR FECHA"
		}
		if	(this.opcion == "proveedor") {
			v_titulo=v_titulo+" POR PROVEEDOR"
		}
		if	(this.opcion == "analista") {
			v_titulo=v_titulo+" POR ANALISTA"
		}
		return v_titulo
	},
	f_muestra_detalle(r_novedad) {
		this.muestreDetalle=true
		this.novedad = r_novedad
		var checkbox1 = document.getElementById("reportar");
		if	(checkbox1 == null) {
			return
		}
		checkbox1.checked=false
		if	(this.novedad.reportar == true) {
			checkbox1.checked=true
			this.fgl_reportar = true
		}
	},
	f_muestra_novedad(r_factura) {
		if	(r_factura == undefined || r_factura == null) {
			return
		}
		this.factura=r_factura
		this.listNovedades = []
		this.muestreLista = false
		Novedades.leaNovedades(this.pais,r_factura.factura,r_factura.identificacion)
		.then((res) => {
			this.listNovedades = res.data.listNovedades
			this.muestreLista = true
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_estado(estado) {
		if	(estado == null) {
			return "Por Reportar"
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado==estado)
		return v_estado.descripcion
	},
	f_fecha(fecha) {
		return fecha.substr(0,10)
	},
	f_valor_fe(precio_fe,cantidad_fe,iva_fe,impuesto_fe) {
		let v_valor_fe=parseFloat(precio_fe)*parseFloat(cantidad_fe)+
			parseFloat(iva_fe)+parseFloat(impuesto_fe)
		return v_valor_fe.toFixed(2)
	},
	f_valor_sap(precio_sap,cantidad_sap,iva_sap,impuesto_sap) {
		let v_valor_sap=parseFloat(precio_sap)*parseFloat(cantidad_sap)+
			parseFloat(iva_sap)+parseFloat(impuesto_sap)
		return v_valor_sap.toFixed(2)
	},
	check() {
		var checkbox1 = document.getElementById("reportar");
		this.novedad.reportar = checkbox1.checked
		if	(this.novedad.reportar == true) {
			this.fgl_reportar = true
		}
	},
	f_grabe_novedad() {
		switch (this.$route.name) {
		case  "Snovedades" :
			Novedades.grabeNovedades(200,this.$store.state.userId,this.listNovedades)
			.catch((err) => {
				console.log(err)
			})
			break;
		case  "Rnovedades" :
			Novedades.grabeNovedades(300,this.$store.state.userId,this.listNovedades)
			.catch((err) => {
				console.log(err)
			})
			break;
		}
		this.f_muestra_novedad()
		this.muestreDetalle=false
		this.fgl_reportar = false
	},
	f_muestre_reportar(r_novedad) {
		if	(r_novedad.precio_fe == r_novedad.precio_sap &&
			r_novedad.cantidad_fe == r_novedad.cantidad_sap) {
			return false
		}
		return true
	},
	f_seleccione_pais() {
		this.paises=true
	},
	uncheck(opcion) {
		this.opcion = ''
		var checkbox1 = document.getElementById("Fecha");
		var checkbox2 = document.getElementById("Proveedor");
		var checkbox3 = document.getElementById("Analista");
		var checkbox4 = document.getElementById("Estado");
		checkbox1.checked=false;
		checkbox2.checked=false;
		checkbox3.checked=false;
		checkbox4.checked=false;

		this.Fecha=false;
		this.Proveedor=false;
		this.Analista=false;
		this.Estado=false;
		if (opcion == 1) {
			checkbox1.checked=true;
			this.Fecha=true;
			this.opcion="fecha"
		}
		if (opcion == 2) {
			checkbox2.checked=true;
			this.Proveedor=true;
			this.opcion="proveedor"
		}
		if (opcion == 3) {
			checkbox3.checked=true;
			this.analista=true;
			this.opcion="analista"
		}
		if (opcion == 4) {
			checkbox4.checked=true;
			this.estado=true;
			this.opcion="estado"
		}
		this.fgl_muestreOpciones=false
		this.fgl_muestreMetricas=false
		this.fgl_muestreFacturas=false
		this.listFacturas=[]
		this.listInformacionNovedades=[]
		this.listInformacionMetricas=[]
		this.listTitulosMetricas=[]
	},
	f_nombre_usuario(id_usuario) {
		const v_usuario = this.users.find((usuario) => usuario.id == id_usuario)
		if	(v_usuario == undefined) {
			return "No definido "+id_usuario
		}
		return v_usuario.name
	},
	f_nombre_estado(estado) {
		const v_estado = this.listEstados.find((estados) => estados.estado == estado)
		if	(v_estado == undefined) {
			return "No definido "+estado
		}
		return v_estado.descripcion
	},
	f_muestra_facturas(r_facturas) {

		this.listFacturas=[]
		let data = {}
		data.criterio = r_facturas
		data.desde = this.desde
		data.hasta = this.hasta
		this.fgl_muestreFacturas=false
		Novedades.leaFacturas(this.pais,this.opcion,data)
		.then((result) => {
			this.listFacturas = result.data.listFacturas
			this.fgl_muestreFacturas=true
			this.fgl_muestreOpciones=false
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al leer facturas")
		})
	},
	f_consulta_informacion() {
		this.fgl_muestreFacturas=false
		this.fgl_muestreMetricas=false
		Novedades.leaInformacionNovedades(this.pais,this.desde,this.hasta,this.opcion)
		.then((result) => {
			this.listInformacionNovedades = result.data.listInformacionNovedades
			this.fgl_muestreOpciones=true
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al leer facturas")
		})
	},
	f_consulta_metricas() {
		this.fgl_muestreFacturas=false
		this.fgl_muestreOpciones=false
		this.listInformacionMetricas=[]
		Novedades.leaInformacionMetricas(this.pais,this.desde,this.hasta,this.opcion)
		.then((result) => {
			this.listInformacionMetricasP=result.data.listInformacionMetricas
			this.listTitulosMetricas = result.data.listTitulosMetricas
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al leer Metricas")
		})
		setTimeout(() => {
			this.fgl_muestreMetricas=true
			this.f_arme_titulos()
		},2000)
	},
	f_arme_titulos() {
		let informacion=[]
		let r_informacion = {}
		this.listTitulosMetricas.forEach((r_estados,idx) => {
			switch (idx) {
				case 0 : this.titulo1 = r_estados.metrica;break;
				case 1 : this.titulo2 = r_estados.metrica;break;
				case 2 : this.titulo3 = r_estados.metrica;break;
				case 3 : this.titulo4 = r_estados.metrica;break;
				case 4 : this.titulo5 = r_estados.metrica;break;
				case 5 : this.titulo6 = r_estados.metrica;break;
				case 6 : this.titulo7 = r_estados.metrica;break;
				case 7 : this.titulo8 = r_estados.metrica;break;
				case 8 : this.titulo9 = r_estados.metrica;break;
				case 9 : this.titulo10 = r_estados.metrica;break;
				case 10 : this.titulo11 = r_estados.metrica;break;
				case 11 : this.titulo12 = r_estados.metrica;break;
				case 12 : this.titulo13 = r_estados.metrica;break;
				case 13 : this.titulo14 = r_estados.metrica;break;
				case 14 : this.titulo15 = r_estados.metrica;break;
			}
		})


		if	(this.opcion == "fecha") {
			r_informacion.fecha="Fecha"
			r_informacion.total=this.listInformacionMetricasP[0].total
		}
		if	(this.opcion == "proveedor") {
			r_informacion.proveedor="Proveedor"
			r_informacion.nombre="Nombre del Proveedor"
			r_informacion.total=this.listInformacionMetricasP[0].total
		}
		if	(this.opcion == "analista") {
			r_informacion.analista="Cdgo"
			r_informacion.nombre="Nombre del Analista"
			r_informacion.total=this.listInformacionMetricasP[0].total
		}
		this.listInformacionMetricasP.forEach((r_informacion) => {
			informacion.push(r_informacion)
		})
		let r1_informacion = {}
		this.listTitulosMetricas.forEach((r_estados,idx) => {
			switch (idx) {
				case 0 : r1_informacion.campo1 = r_estados.idx;break;
				case 1 : r1_informacion.campo2 = r_estados.idx;break;
				case 2 : r1_informacion.campo3 = r_estados.idx;break;
				case 3 : r1_informacion.campo4 = r_estados.idx;break;
				case 4 : r1_informacion.campo5 = r_estados.idx;break;
				case 5 : r1_informacion.campo6 = r_estados.idx;break;
				case 6 : r1_informacion.campo7 = r_estados.idx;break;
				case 7 : r1_informacion.campo8 = r_estados.idx;break;
				case 8 : r1_informacion.campo9 = r_estados.idx;break;
				case 9 : r1_informacion.campo10 = r_estados.idx;break;
				case 10 : r1_informacion.campo11 = r_estados.idx;break;
				case 11 : r1_informacion.campo12 = r_estados.idx;break;
				case 12 : r1_informacion.campo13 = r_estados.idx;break;
				case 13 : r1_informacion.campo14 = r_estados.idx;break;
				case 14 : r1_informacion.campo15 = r_estados.idx;break;
			}
		})
		if	(this.opcion == "fecha") {
			r1_informacion.fecha="TOTAL"
			r1_informacion.total=this.listInformacionMetricasP[0].total
		}
		if	(this.opcion == "proveedor") {
			r1_informacion.nombre="TOTAL"
			r1_informacion.total=this.listInformacionMetricasP[0].total
		}
		if	(this.opcion == "analista") {
			r1_informacion.nombre="TOTAL"
			r1_informacion.total=this.listInformacionMetricasP[0].total
		}
		informacion.push(r1_informacion)
		this.listInformacionMetricas=informacion
	},
	f_formato_fecha(p_fecha) {
		const v_fecha = p_fecha.replaceAll('-','/')
		return v_fecha
	},
	f_columna(columna) {
		this.$toast.success(this.listTitulosMetricas[columna].descripcion)
	},
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 10px solid;
}

</style>
